import React from 'react'
import styled from 'styled-components';
import { Check } from 'lucide-react';
import { FullyCentered } from 'styled/alignment/Center';
import colors from 'theme/colors';
import Text from './Text';

export default function Checkbox({
    selected = false,
    label,
    accentColor = colors.primary,
    textSize,
    style,
    marginTop,
    textStyle = {},
    onSelect = () => false
}) {
    return (
        <Container
            paddingBottom='10px'
            marginTop={marginTop}
            style={style}
            onClick={() => onSelect()}
        >
            <StyledCheckbox selected={selected} accentColor={accentColor}>
                {selected && <Check size={11} strokeWidth={3} color={colors.neutralLight} />}
            </StyledCheckbox>

            <Text
                name={textSize}
                color={selected ? accentColor : colors.night}
                style={textStyle}
            >
                {label}
            </Text>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 20px;
    cursor: pointer;

    ${({ marginTop }) => marginTop && `
        margin-top: ${marginTop} !important;
    `};
`;

const StyledCheckbox = styled(FullyCentered)`
    flex-shrink: 0;
    border: 1px solid ${colors.night};
    border-radius: 5px;
    width: 16px;
    height: 16px;
    margin-right: 10px;
    background: transparent;

    ${({ selected, accentColor }) => selected && `
        border: 1px solid ${accentColor};
        background: ${accentColor};
    `};
`;
